import { render, staticRenderFns } from "./MessageCode.vue?vue&type=template&id=ef734b06&scoped=true"
import script from "./MessageCode.vue?vue&type=script&lang=js"
export * from "./MessageCode.vue?vue&type=script&lang=js"
import style0 from "./MessageCode.vue?vue&type=style&index=0&id=ef734b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef734b06",
  null
  
)

export default component.exports